class ProductsDropdown extends HTMLElement {
  constructor() {
    super()
    this.toggleButton = this.querySelector('.Products-Dropdown__Label')
    this.dropdownContainer = this.querySelector('.Products-Dropdown__Selector')
    this.dropdownList = this.querySelector('.Products-Dropdown__List')
    
    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    
    this.toggleButton.addEventListener('click', this.toggleDropdown)
  }

  connectedCallback() {
    document.addEventListener('click', this.handleClickOutside, true)
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleClickOutside, true)
  }

  toggleDropdown(event) {
    event.stopPropagation()
    const isOpen = this.dropdownContainer.classList.contains('is-open')
    document.querySelectorAll('products-dropdown .Products-Dropdown__Selector.is-open').forEach(dropdown => {
      dropdown.classList.remove('is-open')
      dropdown.querySelector('.Products-Dropdown__List').style.setProperty('--dropdown-max-height', '0px')
    })
    
    if (!isOpen) this.openDropdown()
  }

  openDropdown() {
    this.dropdownList.style.setProperty('--dropdown-max-height', 'auto')
    this.dropdownList.style.opacity = '0'
    this.dropdownList.style.display = 'block'
    
    requestAnimationFrame(() => {
      const maxHeight = this.dropdownList.scrollHeight + 'px'
      this.dropdownList.style.setProperty('--dropdown-max-height', maxHeight)
      this.dropdownList.style.opacity = '1'
      this.dropdownContainer.classList.add('is-open')
    })
  }
  

  closeDropdown() {
    this.dropdownContainer.classList.remove('is-open')
    this.dropdownList.style.setProperty('--dropdown-max-height', '0px')
  }

  handleClickOutside(event) {
    if (!this.dropdownContainer.contains(event.target) && !this.toggleButton.contains(event.target)) {
      this.closeDropdown()
    }
  }
}

customElements.define('products-dropdown', ProductsDropdown)